import type { Observable } from 'rxjs';
import { ownedError } from 'core/utils/owned-error';
import { defer, EMPTY } from 'rxjs';
import { catchError, finalize, startWith, switchMap, tap, throwIfEmpty } from 'rxjs/operators';

export interface RequestStatus {
  loading: boolean;
  failed: boolean;
}

export function reloadableRequest<T>(
  request: () => Observable<T>,
  reloader: Observable<unknown>,
  status: RequestStatus,
  changed: () => void,
): Observable<T> {
  return reloader.pipe(
    startWith(undefined),
    switchMap(() => defer(() => {
      status.loading = true;
      status.failed = false;
      changed();
      return request();
    }).pipe(
      throwIfEmpty(() => ownedError(new Error('Request completed without data'))),
      tap(() => {
        status.loading = false;
        changed();
      }),
      catchError(() => {
        status.failed = true;
        return EMPTY;
      }),
      finalize(() => {
        status.loading = false;
        changed();
      }),
    )),
  );
}
